import { ProprieteAffichee } from "../proprieteAffichee";

export class Mineralisation {
    id: number;
    name= '';
    shortName= '';
    regionId = 0;
    siteId?: number;
    isActive = true;


    getProprietesAffichees() {
        let tab: ProprieteAffichee[] = [];
        tab.push(new ProprieteAffichee('id', 'GLOBAL.IDENTIFICATEUR'));
        tab.push(new ProprieteAffichee('name', 'GLOBAL.NOM'));
        tab.push(new ProprieteAffichee('shortName', 'PRODUCTS.NAMESHORT'));
        return tab;
      }
  }
  